import React from 'react'
import { Link } from 'react-router-dom'
import logo1 from '../assets/logo1.webp'
import logo2 from '../assets/logo2.webp'
import logo3 from '../assets/logo3.webp'
import logo4 from '../assets/logo4.webp'
import logo5 from '../assets/logo5.webp'
import BlogCard from './BlogCard'

export default function Blog() {


  return (<div>

    <div className=' bg-hero-pattern -z-10' >
      <div className=' flex justify-center items-center  flex-col bg-[rgb(59,68,152,0.9)] bg-cover bg-no-repeat  h-[60vh]   text-white xl:px-[9vw]  text-center   ' >
        <p
          className='text-xl tracking-wide  p-2'>OUR BLOG</p>
        <h1 h1 className='text-4xl lg:text-7xl p-2 tracking-wide font-semibold'>Blog Details</h1>
        <span className='mt-2 p-3 text-xl font-sans '>
          <Link to='/home' className='hover:text-gray-400'>Home</Link> / Blog
        </span>
      </div>
    </div>


    <div className='flex flex-wrap justify-center  items-center m-4 ' >
      <div> <p className='text-[#009640] text-2xl text-center tracking-wide'>OUR BLOG</p>
        <h1 className=' text-4xl lg:text-6xl font-semibold  sm:mt-3 text-blue-900 tracking-wider py-3 ' > Latest     <span className='text-[#009640]'>Post </span>from our   <span className='text-[#009640]'>Blogs </span>Happy</h1></div>
    </div>
    <BlogCard />
    <BlogCard />
    <BlogCard />

    <div className='flex flex-wrap my-10 gap-10 justify-evenly items-center ' >
      <img src={logo1} alt="logo1" />
      <img src={logo2} alt="logo1" />
      <img src={logo3} alt="logo1" />
      <img src={logo4} alt="logo1" />
      <img src={logo5} alt="logo1" />
    </div>

    <div className="flex flex-col sm:flex-row text-white px-5 justify-between lg:px-28 py-10 bg-[#009640] ">
      <div> <p className=' text-2xl tracking-wide'>NEWSLETTER</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-3 tracking-wide py-3 ' > Subscribe our Newsletter</h1></div>
      <div>
        <input type="text" className='p-2 bg-transparent sm:-ml-6 h-10 text-white font-sans border-2 border-white' placeholder=' Enter Your Email Address' /><button className='bg-[rgb(63,65,153)]  font-sans h-10 px-2' >Subscribe</button>
      </div>
    </div>

  </div>
  )
}
